export default "__VITE_ASSET__8rmMFSI3__"